// Minnesotaänger Mini App — v1 selectors.
// New code (not from telegram-tt). Read-only accessors over GlobalState.miniapp.

import type { ApiMiniAppMessage } from '../../api/miniapp/types';
import type { MiniAppPendingOperation } from '../miniapp/types';
import type { GlobalState } from '../types';

export function selectConversations(global: GlobalState) {
  return global.miniapp.conversations;
}

export function selectIsLoadingConversations(global: GlobalState) {
  return global.miniapp.isLoadingConversations;
}

export function selectConversationsError(global: GlobalState): string | null {
  return global.miniapp.conversationsError;
}

export function selectActiveChatId(global: GlobalState) {
  return global.miniapp.activeChatId;
}

export function selectActiveChat(global: GlobalState) {
  const chatId = global.miniapp.activeChatId;
  if (!chatId) return undefined;
  return global.miniapp.conversations.find((c) => c.chat_id === chatId);
}

// Messages are stored newest last (rendering order).
export function selectChatMessages(global: GlobalState, chatId: string): ApiMiniAppMessage[] {
  return global.miniapp.messagesByChatId[chatId] ?? [];
}

export function selectOlderCursor(global: GlobalState, chatId: string): number | null | undefined {
  return global.miniapp.olderCursorByChatId[chatId];
}

export function selectIsLoadingMessages(global: GlobalState, chatId: string) {
  return global.miniapp.isLoadingMessagesChatIds.includes(chatId);
}

export function selectIsLoadingMore(global: GlobalState, chatId: string) {
  return global.miniapp.isLoadingMoreChatIds.includes(chatId);
}

export function selectIsSending(global: GlobalState, chatId: string) {
  return global.miniapp.sendingChatIds.includes(chatId);
}

export function selectSendError(global: GlobalState, chatId: string): string | null {
  return global.miniapp.sendFailedByChatId[chatId] ?? null;
}

export function selectSelectedMessageIds(global: GlobalState, chatId: string): string[] {
  return global.miniapp.selectedMessageIdsByChatId[chatId] ?? [];
}

// v1 (fix-list E): reply targets are number event_ids (l0 rowids).
export function selectReplyingToEventId(global: GlobalState, chatId: string): number | undefined {
  return global.miniapp.replyingToEventIdByChatId[chatId];
}

export function selectComposerText(global: GlobalState, chatId: string): string {
  return global.miniapp.composerTextByChatId[chatId] ?? '';
}

export function selectPendingOperations(
  global: GlobalState,
  chatId: string,
): MiniAppPendingOperation[] {
  return global.miniapp.pendingOperationsByChatId[chatId] ?? [];
}

export function selectDialog(global: GlobalState) {
  return global.miniapp.dialog;
}

export function selectMessage(
  global: GlobalState,
  chatId: string,
  eventId: number,
): ApiMiniAppMessage | undefined {
  return selectChatMessages(global, chatId).find((m) => m.event_id === eventId);
}
